import Button from "components/shared/button";
import { JSX } from "react";
import useTranslation from "utils/hooks/useTranslation";

export interface CommandPanelToolbarProps {
  save?: () => any;
  saveAndClose?: () => void;
  additionalElement?: JSX.Element;
  isDisabledMode?: boolean;
}

export const CommandPanelToolbar: React.FC<CommandPanelToolbarProps> = ({
  save,
  saveAndClose,
  additionalElement,
  isDisabledMode,
}) => {
  const { t } = useTranslation();

  return (
    <group
      data-space="10"
      data-border=""
      data-align="center"
      data-gap="10"
      data-wrap="no"
    >
      {saveAndClose ? (
        <Button primary onClick={saveAndClose} disabled={isDisabledMode}>
          <text>{t("SaveAndClose")}</text>
        </Button>
      ) : null}
      {save ? (
        <Button highlight onClick={save} disabled={isDisabledMode}>
          <text>{t("Save")}</text>
        </Button>
      ) : null}
      {additionalElement ?? null}
    </group>
  );
};
